import { Injectable } from '@angular/core';
import { ServiceDelete, ServiceListById } from '@core/models';
import { Attachment } from '@core/models/attachment.model';
import { ApiService, LoadingService, SnackbarService } from '../../services';
import { first, Observable } from 'rxjs';
import { AttachmentLoaderKey } from '@core/enums';

const ENDPOINT = 'v1/attachments';

@Injectable({
  providedIn: 'root',
})
export class AttachmentApiService implements ServiceListById<Attachment[]>, ServiceDelete<{ id: string }> {
  constructor(
    private api: ApiService,
    private loader: LoadingService,
    private snack: SnackbarService,
  ) {}

  listById(id: string): Observable<Attachment[]> {
    return this.api
      .get<Attachment[]>(`${ENDPOINT}/orders/${id}`)
      .pipe(first(), this.loader.set(AttachmentLoaderKey.LIST_ATTACHMENTS), this.snack.operator());
  }

  upload(id: string, file: File): Observable<Attachment> {
    const requestData: FormData = this.prepareFormData(file);
    return this.api
      .post<Attachment, FormData>(`${ENDPOINT}/orders/${id}`, requestData)
      .pipe(first(), this.loader.set(AttachmentLoaderKey.UPLOAD_ATTACHMENT), this.snack.operator());
  }

  delete(id: string): Observable<{ id: string }> {
    return this.api
      .delete<{ id: string }>(ENDPOINT, id)
      .pipe(first(), this.loader.set(AttachmentLoaderKey.DELETE_ATTACHMENT), this.snack.operator('Attachment deleted'));
  }

  private prepareFormData(file: File): FormData {
    const formData: FormData = new FormData();
    formData.set('file', file);
    return formData;
  }
}
